import React from 'react'
import { Link } from 'react-router-dom'
import { Container } from '@offerzen/pinata-shame'

import AnimatedDino from './AnimatedDino'

import styles from './styles'

const Footer = () => {
  return (
    <footer className={styles.dinoFooter}>
      <Container className={styles.container}>
        <AnimatedDino />

        <ul className={styles.footerNavigation}>
          <li><Link to="/terms">Terms</Link></li>
          <li><a href="/code_of_conduct">Code of Conduct</a></li>
          <li><a href="/privacy-centre">Privacy Centre</a></li>
        </ul>
      </Container>
    </footer>
  )
}

export default Footer
